function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-right-wide_svg__clip0)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#1E388B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.934 4.27a.917.917 0 000 1.297l4.853 4.851-4.853 4.85a.917.917 0 001.298 1.299l5.5-5.5a.918.918 0 000-1.298l-5.5-5.5a.917.917 0 00-1.298 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.082 10.418a.917.917 0 00-.916-.917H.916a.917.917 0 000 1.834h19.25a.916.916 0 00.916-.917z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-right-wide_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h22v22H0z"
})));
function SvgArrowRightWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgArrowRightWide;